import React, { Component } from 'react';
import PrivacyPage from '../PrivacyPage'
import Home from './Home';
import '../App.css';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';

class App extends Component {

  constructor(props){
    super()
  }

  render() {
    return (
      <Router>
          <Switch>
              <Route exact path='/privacy' component={PrivacyPage} />
              <Route exact path='/' component={Home} />
          </Switch>
      </Router>
      
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/components/App.js